<template>
  <div class="pb-2">
    <ValidationObserver v-slot="{ handleSubmit }" ref="formTransferir">
      <b-form @submit.prevent="handleSubmit(ofertar)">
        <div>
          <PRow>
            <PCol md="6">
              <div class="pl-2 pr-3">
                <TransferenciaDetalle :transferencia="transferencia" />
              </div>
            </PCol>
            <PCol md="6">
              <div class="pl-2 pr-3">
                <div>
                  <b-card-title class="data-form pl-3 pt-4">
                    {{ $t("label.transferir") }}
                  </b-card-title>
                  <div>
                    <PRow>
                      <PCol>
                        <PDataLine
                          class="mb-0"
                          :value="clienteDataOfertaFiltered"
                          :fields="clientFieldOfertaFiltered"
                          :showSeparators="true"
                        />
                      </PCol>
                    </PRow>
                    <PRow>
                      <PCol>
                        <PDataLine
                          class="mb-0"
                          :value="{
                            saldoRestante: `${
                              transferencia.soVOferta.divisa.simbolo
                            } ${filterNumber(saldoRestante, 2)}`,
                            totalOfertar: `${transferencia.soVOferta.divisa.simbolo} ${filterNumber(
                              saldoOfertar,
                              2
                            )}`,
                          }"
                          :fields="{
                            saldoRestante: { title: $t('label.saldo.restante') },
                            totalOfertar: { title: $t('label.total.ofertar') },
                          }"
                          :widthContent="true"
                          :showSeparators="true"
                        />
                      </PCol>
                    </PRow>
                    <PRow v-if="transferencia.soVDetalleTransferencias.length">
                      <PCol>
                        <PTableSimple
                          :fields="fields_PTableSimple"
                          :items="transferencia.soVDetalleTransferencias"
                        >
                          <template #denominacion="{ item }">
                            {{ item.soCalidadDenominacion.denominacion.codDenominacion }}
                            {{ item.soCalidadDenominacion.desCalidad }}
                          </template>
                          <template #disponible="{ item }">
                            {{ transferencia.soVOferta.divisa.simbolo }}
                            {{ filterNumber(item.soVDetalleOferta.cantidadDisponible, 2) }}
                          </template>
                          <template #ofertado="{ item, showExtend }">
                            <div
                              @click="showExtend"
                              class="denominacion-importe"
                              v-if="
                                item &&
                                item.soVDetalleOferta &&
                                transferencia.soVDemanda.checkParcial &&
                                item.soVDetalleOferta.cantidadDisponible > 0
                              "
                            >
                              {{ transferencia.soVOferta.divisa.simbolo }}
                              {{ filterNumber(item.soCalidadDenominacion.importe, 2) }}
                            </div>
                            <div v-else>
                              {{ transferencia.soVOferta.divisa.simbolo }}
                              {{ filterNumber(item.cantidadDemandada, 2) }}
                            </div>
                          </template>
                          <template #extend="{ item, index }">
                            <ValidationProvider
                              v-slot="{ errors }"
                              :rules="`required|min_value:0|valid-denomination:${item.soCalidadDenominacion.denominacion.numValue}`"
                              :name="`cantidad-denominacion_${index}`"
                              v-if="
                                transferencia.soVDemanda.checkParcial &&
                                item.soVDetalleOferta.cantidadDisponible > 0
                              "
                            >
                              <b-card class="input-card">
                                <b-card-body>
                                  <PRow>
                                    <PCol offset-lg="3" offset-md="3" lg="6" md="6">
                                      <b-form-group>
                                        <b-input
                                          type="number"
                                          min="0"
                                          :max="
                                            item.cantidadDemandada <=
                                            item.soVDetalleOferta.cantidadDisponible
                                              ? item.cantidadDemandada
                                              : item.soVDetalleOferta.cantidadDisponible
                                          "
                                          :step="item.soCalidadDenominacion.denominacion.numValue"
                                          v-model="item.soCalidadDenominacion.importe"
                                          :name="`cantidad-denominacion_${index}`"
                                          :id="`cantidad-denominacion_${index}`"
                                          :state="errors[0] ? false : null"
                                          :aria-describedby="`cantidad-denominacion-feedback_${index}`"
                                        />
                                      </b-form-group>
                                    </PCol>
                                  </PRow>
                                  <b-input
                                    type="range"
                                    min="0"
                                    :max="
                                      item.cantidadDemandada <=
                                      item.soVDetalleOferta.cantidadDisponible
                                        ? item.cantidadDemandada
                                        : item.soVDetalleOferta.cantidadDisponible
                                    "
                                    :step="item.soCalidadDenominacion.denominacion.numValue"
                                    v-model="item.soCalidadDenominacion.importe"
                                    class="mt-1"
                                  />
                                </b-card-body>
                              </b-card>

                              <b-form-invalid-feedback
                                :id="`cantidad-denominacion-feedback_${index}`"
                                class="d-block"
                              >
                                {{ errors[0] }}
                              </b-form-invalid-feedback>
                            </ValidationProvider>
                          </template>
                        </PTableSimple>
                      </PCol>
                    </PRow>
                    <PRow>
                      <PCol col="6" md="4">
                        <label class="label-form" for="coste">{{ $t("label.coste") }}</label>
                        <span class="data-form" id="coste">
                          {{ $t(`label.coste.${transferencia.soVDemanda.coste.codParametro}`) }}
                        </span>
                      </PCol>
                      <PCol
                        col="6"
                        md="4"
                        v-if="transferencia.clientexdelDemanda.cliente.pais.hasTasa"
                      >
                        <label class="label-form" for="tasa">{{ $t("label.tasa") }}</label>
                        <span
                          v-if="!transferencia.clientexdelDemanda.cliente.pais.hasTasaEnteros"
                          class="data-form"
                          id="tasa"
                        >
                          {{ filterNumber(transferencia.soVDemanda.numTasa, 5) }} %
                        </span>
                        <span
                          v-if="transferencia.clientexdelDemanda.cliente.pais.hasTasaEnteros"
                          class="data-form"
                          id="tasa"
                        >
                          {{ Math.round(transferencia.soVDemanda.numTasa * 100000) }} x 10.000
                        </span>
                      </PCol>
                    </PRow>
                    <PRow v-if="isShowBankField">
                      <PCol md="6">
                        <label class="label-form" for="cuentaCorriente">
                          {{ $t("label.cuentaCorriente") }}
                        </label>
                        <span class="data-form" id="cuentaCorriente">
                          {{ transferencia.soVOferta.cuentaCorriente }}
                        </span>
                      </PCol>
                      <PCol md="6">
                        <label class="label-form" for="agNumeroSucursal">
                          {{ $t("label.agNumeroSucursal") }}
                        </label>
                        <span class="data-form" id="agNumeroSucursal">
                          {{ transferencia.soVOferta.agNumeroSucursal }}
                        </span>
                      </PCol>
                    </PRow>
                    <PRow v-if="isShowBankField">
                      <PCol md="6">
                        <label class="label-form" for="ispbBanco">
                          {{ $t("label.ispbBanco") }}
                        </label>
                        <span class="data-form" id="ispbBanco">
                          {{ transferencia.soVOferta.ispbBanco }}
                        </span>
                      </PCol>
                      <PCol md="6">
                        <label class="label-form" for="cnpjPersona">
                          {{ $t("label.cnpjPersona") }}
                        </label>
                        <span class="data-form" id="cnpjPersona">
                          {{ transferencia.soVOferta.cnpjPersona }}
                        </span>
                      </PCol>
                    </PRow>
                    <PRow>
                      <PCol>
                        <label class="label-form" for="observaciones">
                          {{ $t("label.observaciones") }}
                        </label>
                        <span class="data-form" id="observaciones">
                          {{ transferencia.soVOferta.observaciones }}
                        </span>
                      </PCol>
                    </PRow>
                  </div>
                </div>
              </div>
            </PCol>
          </PRow>
          <PRow class="mb-3 mt-5">
            <PCol class="text-center">
              <b-button
                pill
                variant="outline-primary"
                class="p-button-secondary mr-4"
                @click="cancelar"
                >{{ $t("label.cancelar") }}</b-button
              >
              <b-button
                pill
                variant="primary"
                class="p-button-primary ml-4"
                :disabled="continuarCondition"
                type="submit"
                >{{ $t("label.transferir") }}</b-button
              >
            </PCol>
          </PRow>
        </div>
      </b-form>
    </ValidationObserver>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { IDetalleTransferenciaParams, ITransferencia } from "@/entities";
import { ITransferenciaParams } from "@/services";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import VueFilters from "@/vue-filters";
import TransferenciaDetalle from "@/pages/transferencias/common/TransferenciaDetalle.vue";

@Component({
  name: "transferir-modal",
  mixins: [VueFilters],
  components: {
    TransferenciaDetalle,
    ValidationObserver,
    ValidationProvider,
  },
})
export default class AceptarDemanda extends Vue {
  @Prop({ required: true }) transferencia!: ITransferencia;
  isShowBankField = false;

  $refs!: {
    formTransferir: InstanceType<typeof ValidationObserver>;
  };

  mounted(): void {
    this.isShowBankField =
      this.transferencia.soVOferta.clientexdel.cliente.pais.hasInfoBancaria || false;
    if (this.transferencia.soVDemanda.checkParcial) {
      this.transferencia.soVDetalleTransferencias.forEach((value) => {
        this.$set(value.soCalidadDenominacion, "importe", 0);
      });
    }
  }

  get continuarCondition(): boolean {
    return !(
      !this.transferencia.soVDemanda.checkParcial ||
      (this.saldoOfertar > 0 && this.transferencia.soVDemanda.checkParcial)
    );
  }

  get fields_PTableSimple(): { key: string; label: string }[] {
    return [
      { key: "denominacion", label: this.$t("label.denominacion") },
      { key: "disponible", label: this.$t("label.disponible") },
      { key: "ofertado", label: this.$t("label.ofertado") },
    ];
  }

  get saldoRestante(): number {
    return this.transferencia.soVOferta.cantidadDisponible - this.saldoOfertar;
  }

  get saldoOfertar(): number {
    let sumaImportes = 0;
    if (this.transferencia.soVDemanda.checkParcial) {
      this.transferencia.soVDetalleTransferencias.forEach((value) => {
        if (value.soCalidadDenominacion.importe) {
          sumaImportes = Number(sumaImportes) + Number(value.soCalidadDenominacion.importe);
        }
      });
      return sumaImportes;
    } else {
      return this.transferencia.cantidadDemandada;
    }
  }

  cancelar(): void {
    this.$emit("cancel");
  }

  async ofertar(): Promise<void> {
    const detalles: IDetalleTransferenciaParams[] = [];
    if (this.transferencia.soVDemanda.checkParcial) {
      this.transferencia.soVDetalleTransferencias.forEach((value) => {
        if (value.soCalidadDenominacion.importe > 0) {
          detalles.push({ id: value.id, importe: value.soCalidadDenominacion.importe });
        }
      });
    }
    const transferenciaParams: ITransferenciaParams = {
      id: this.transferencia.id,
      detalles: detalles,
    };
    this.$emit("action", {
      action: "transferir",
      data: transferenciaParams,
    });
  }

  get clientFieldOfertaFiltered(): any {
    const fields: any = {};

    if (this.transferencia.clientexdelOferta.cliente.desCliente) {
      fields.cliente = { title: this.$t("label.cliente") };
    }
    if (this.transferencia.clientexdelOferta.delegacion.desDelegacion) {
      fields.delegacion = { title: this.$t("label.delegacion") };
    }
    if (this.transferencia.soVOferta.divisa) {
      fields.divisa = { title: this.$t("label.divisa") };
    }
    if (this.transferencia.soVOferta.transportadora?.descripcion) {
      fields.transportadora = { title: this.$t("label.transportadora") };
    }
    return fields;
  }

  get clienteDataOfertaFiltered(): any {
    const data: any = {};

    if (this.transferencia.clientexdelOferta.cliente.desCliente) {
      data.cliente = this.transferencia.clientexdelOferta.cliente.desCliente;
    }
    if (this.transferencia.clientexdelOferta.delegacion.desDelegacion) {
      data.delegacion = this.transferencia.clientexdelOferta.delegacion.desDelegacion;
    }
    if (this.transferencia.soVOferta.divisa) {
      data.divisa =
        this.transferencia.soVOferta.divisa.simbolo +
        " " +
        this.transferencia.soVOferta.divisa.codDivisa;
    }
    if (this.transferencia.soVOferta.transportadora?.descripcion) {
      data.transportadora = this.transferencia.soVOferta.transportadora.descripcion;
    }
    return data;
  }
}
</script>

<style lang="scss" scoped>
.label-form {
  font-size: 12px;
  line-height: 16px;
  font-weight: normal;
  color: var(--secundario-prosegur-oscuro-plus-10);
  margin-bottom: 0;
}

.denominacion-importe {
  color: var(--amarillo-prosegur);
  cursor: pointer;
}
.input-card {
  margin: 1rem 0;
  padding: 1rem;
  border-radius: 6px;
  border: solid 0.7px #f1f0f0;
  background-color: rgba(255, 209, 2, 0.04);
}
.textError {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
}
.buttons_DemandarSobreOferta {
  display: flex;
  justify-content: center;
}
.textarea {
  height: 100px;
  width: 100%;
  border-radius: 6px;
  border: solid 1px #ced4da;
}
.data-form {
  font-size: 14px;
  font-weight: bold;
  line-height: 16px;
  color: var(--secundario-prosegur-claro);
  text-transform: initial;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  width: 99%;
  overflow: hidden;
}
</style>
